export const BARQUETTES_PER_EMPLACEMENT = 4;
export const DEFAULT_EMP_MIN = 10;
export const DEFAULT_EMP_MAX = 58;
export const DEFAULT_ALL_EMPS = Array.from(
  { length: DEFAULT_EMP_MAX - DEFAULT_EMP_MIN + 1 },
  (_, i) => DEFAULT_EMP_MIN + i
);

export const emptyDistributorForm = {
  name: "",
  type: "AUTOMATIQUE",
  code: "",
  contact_name: "",
  email: "",
  phone: "",
  address: "",
  city: "",
  postal_code: "",
  country: "Suisse",
  siret: "",
  notes: "",
  hide_emplacement_grid: false,
  nayax_machine_id: "",
  price_tier: "direct",
  displayed_product_ids: [],
  displayed_product_rails: {},
  // Phase 33 — Corporate / Novelis (machine subventionnée par entreprise hôte)
  is_corporate: false,
  employee_discount_percent: null,
  corporate_monthly_min_chf: null,
  corporate_billing_email: "",
  // Phase 101cw (Feb 2026) — Tranches de facturation + prix par produit + TVA
  corporate_participation_tiers: [],
  corporate_tva_rate: 2.6,
  employee_price_overrides: {},
  // Phase 101bn — Typologie revente (Oseo etc.) : par défaut fabrication
  default_sale_type: "fabrication",
  // Phase 101ge/gf — Métadonnées administratives Canton VS + employés
  is_internal_stock: false,
  is_employees_only: false,
  installed_at: "",
};

// Accepte "950" (capacité défaut) ou "950×5" / "950x5" / "950*5" / "950:5" / "950(5)" (capacité 5)
export function parseCustomEmplacementList(raw) {
  const tokens = String(raw)
    .split(/[,;\s\n\t]+/)
    .map((x) => x.trim())
    .filter(Boolean);
  const seen = new Map();
  for (const tok of tokens) {
    const m = tok.match(/^(\d+)\s*[x×*:(]\s*(\d+)\)?$/i) || tok.match(/^(\d+)$/);
    if (!m) continue;
    const number = Number(m[1]);
    const capacity = m[2] ? Number(m[2]) : null;
    if (!Number.isInteger(number) || number < 1 || number > 9999) continue;
    if (capacity !== null && (!Number.isInteger(capacity) || capacity < 1 || capacity > 50)) continue;
    seen.set(number, capacity);
  }
  const items = [];
  for (const [number, capacity] of seen.entries()) {
    items.push({ number, capacity });
  }
  items.sort((a, b) => a.number - b.number);
  return items;
}
